import { commonMessages } from '../../util/messages'

export const messages = {
  common: commonMessages,
  create: {
    success: 'Issuer successfully created',
    error: 'Error creating issuer',
  },
  update: {
    success: 'Issuer successfully updated',
    error: 'Error updating issuer',
  },
  createRfqEmail: {
    success: 'RFQ Email successfully created',
    error: 'Error creating RFQ Email',
  },
  deleteRfqEmail: {
    success: 'RFQ Email successfully deleted',
    error: 'Error deleting RFQ Email',
  },
  updateRfqEmail: {
    success: 'RFQ Email successfully updated',
    error: 'Error updating RFQ Email',
  },
}
